export const ACS_RECIRECT_DATA_START = 'ACS_RECIRECT_DATA_START';
export const ACS_RECIRECT_DATA_SUCCESS = 'ACS_RECIRECT_DATA_SUCCESS';
export const ACS_RECIRECT_DATA_FAILURE = 'ACS_RECIRECT_DATA_FAILURE';

export const SET_DATA = 'SET_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';

export const FATAL_FAILURE = 'FATAL_FAILURE';
